// extracted by mini-css-extract-plugin
export var documentation = "_ku-1";
export var menu = "_ku-0";